var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/Info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Info",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-information-circle@24x24",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,14 L11.3333333,14 C10.5969537,14 10,13.4030463 10,12.6666667 L10,9.33333333 C10,8.9651435 9.70152317,8.66666667 9.33333333,8.66666667 L8.66666667,8.66666667",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66666667,5.33333333 C9.48257175,5.33333333 9.33333333,5.48257175 9.33333333,5.66666667 C9.33333333,5.85076158 9.48257175,6 9.66666667,6 C9.85076158,6 10,5.85076158 10,5.66666667 C10,5.48257175 9.85076158,5.33333333 9.66666667,5.33333333 L9.66666667,5.33333333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10 C0,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.3831382bfcb9958732373f8a9f67261c.svg";
export { ForwardRef as ReactComponent };